module.exports = __webpack_public_path__ + "img/add-patient.89cdd843.svg";